import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-title" }
const _hoisted_2 = { class: "row g-3" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = {
  key: 0,
  class: "text-muted d-block"
}
const _hoisted_5 = {
  key: 1,
  class: "text-danger d-block"
}
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-check mt-2" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = {
  key: 0,
  class: "alert alert-danger mt-3 mb-0"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_ModalConsulte = _resolveComponent("ModalConsulte")!

  return (_openBlock(), _createBlock(_component_ModalConsulte, {
    ref: "modalRef",
    "hide-footer": false,
    modalWidth: "700px !important"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.tituloModal), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            class: "form-label",
            for: "campo-exemplar-45e2"
          }, "Exemplar", -1)),
          _createVNode(_component_MultiSelect, {
            id: "campo-exemplar-45e2",
            modelValue: _ctx.bibExemplarSelecionado,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bibExemplarSelecionado) = $event)),
            mode: "single",
            options: _ctx.pesquisarExemplares,
            "filter-results": false,
            "min-chars": 0,
            "resolve-on-load": true,
            delay: 300,
            searchable: true,
            "can-clear": true,
            "value-prop": "bibExemplarId",
            label: "descricao",
            "track-by": "descricao",
            "no-options-text": "Digite o tombamento, o código de barras ou o título",
            "no-results-text": "Nenhum exemplar encontrado nesta biblioteca",
            placeholder: "Pesquise pelo tombamento, código de barras ou título",
            "aria-label": "Pesquisar exemplar por tombamento, código de barras ou título",
            onChange: _ctx.selecionarExemplar
          }, null, 8, ["modelValue", "options", "onChange"]),
          (_ctx.exemplarDescricao)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.exemplarDescricao), 1))
            : _createCommentVNode("", true),
          (_ctx.avisoExemplar)
            ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.avisoExemplar), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            class: "form-label",
            for: "campo-dataEmprestimo-45e2"
          }, "Data de Empréstimo", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.dataEmprestimo) = $event)),
            type: "date",
            class: "form-control",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.recalcularVencimento && _ctx.recalcularVencimento(...args))),
            id: "campo-dataEmprestimo-45e2"
          }, null, 544), [
            [_vModelText, _ctx.form.dataEmprestimo]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[12] || (_cache[12] = _createElementVNode("label", {
            class: "form-label",
            for: "campo-dataVencimento-45e2"
          }, "Data de Vencimento", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.dataVencimento) = $event)),
            type: "date",
            class: "form-control",
            readonly: "",
            id: "campo-dataVencimento-45e2"
          }, null, 512), [
            [_vModelText, _ctx.form.dataVencimento]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              id: "especial",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.especialMarcado) = $event)),
              class: "form-check-input",
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.especialMarcado]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              class: "form-check-label",
              for: "especial"
            }, "Especial", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[14] || (_cache[14] = _createElementVNode("label", {
            class: "form-label",
            for: "campo-observacao-45e2"
          }, "Observação", -1)),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.observacao) = $event)),
            rows: "4",
            class: "form-control",
            id: "campo-observacao-45e2"
          }, null, 512), [
            [_vModelText, _ctx.form.observacao]
          ])
        ])
      ]),
      (_ctx.mensagemErro)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.mensagemErro), 1))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      (_ctx.isEdicao() ? _ctx.permissaoTela.alterar : _ctx.permissaoTela.incluir)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-outline-primary",
            disabled: _ctx.salvando || _ctx.excluindo,
            title: "Salvar a operação e emitir o comprovante",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.salvar(true)))
          }, "Comprovante", 8, _hoisted_12))
        : _createCommentVNode("", true),
      (_ctx.isEdicao() && _ctx.permissaoTela.excluir)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "btn btn-outline-danger",
            disabled: _ctx.salvando || _ctx.excluindo,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
          }, _toDisplayString(_ctx.excluindo ? "Excluindo..." : "Excluir"), 9, _hoisted_13))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light",
        disabled: _ctx.salvando || _ctx.excluindo,
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, "Cancelar", 8, _hoisted_14),
      (_ctx.isEdicao() ? _ctx.permissaoTela.alterar : _ctx.permissaoTela.incluir)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "btn btn-primary",
            disabled: _ctx.salvando || _ctx.excluindo,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.salvar()))
          }, _toDisplayString(_ctx.salvando ? "Salvando..." : "OK"), 9, _hoisted_15))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}